/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import styles from '../../../../styles/components/pageComponents/coach/GenericTable.module.css';
import { GenericTableProps } from '../../../../types/generic';
import { Eye, MessageSquare, Trash2, X } from 'lucide-react';

const GenericTable: React.FC<GenericTableProps> = ({
	title,
	columns,
	data,
	onClose,
	onView,
	onMessage,
	onDelete,
}) => {
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 10;

	// Pagination Logic
	const totalItems = data.length;
	const totalPages = Math.ceil(totalItems / itemsPerPage);
	const startIndex = (currentPage - 1) * itemsPerPage;
	const currentData = data.slice(startIndex, startIndex + itemsPerPage);

	const handlePageChange = (page: number) => {
		setCurrentPage(page);
	};

	return (
		<div className={styles.overlay}>
			<div className={styles.container}>
				<div className={styles.header}>
					<div className={styles.headerTitleGroup}>
						<div className={styles.titleRow}>
							<h2 className={styles.title}>{title}</h2>
							{onClose && (
								<button
									onClick={onClose}
									className={styles.closeBtn}
								>
									<X size={24} />
								</button>
							)}
						</div>

						{/* PAGINATION SECTION */}
						<div className={styles.paginationRow}>
							<div className={styles.pageNumbers}>
								{Array.from(
									{ length: totalPages },
									(_, i) => i + 1
								).map(page => (
									<button
										key={page}
										className={`${styles.pageBtn} ${currentPage === page ? styles.activePage : ''}`}
										onClick={() => handlePageChange(page)}
									>
										{page}
									</button>
								))}
							</div>
							<div className={styles.showingText}>
								Showing {currentData.length} of {totalItems}
							</div>
						</div>
					</div>
				</div>

				<div className={styles.tableWrapper}>
					<table className={styles.table}>
						<thead>
							<tr>
								{columns.map(col => (
									<th key={col.key}>{col.label}</th>
								))}
							</tr>
						</thead>
						<tbody>
							{currentData.map(row => (
								<tr key={row.id}>
									<td
										data-label="Full Name"
										className={styles.nameCell}
									>
										<div className={styles.avatar}>
											{row.avatar ? (
												<img src={row.avatar} alt="" />
											) : (
												<div
													className={
														styles.placeholder
													}
												/>
											)}
										</div>
										<span>{row.name}</span>
									</td>
									<td data-label="Enrolled Program">
										{row.program}
									</td>
									<td data-label="ICC Credentials">
										{row.credentials}
									</td>
									<td data-label="Role">{row.role}</td>
									<td data-label="Quick Actions">
										<div className={styles.actions}>
											{/* <button className={styles.actionBtn} onClick={() => onView?.(row)}>
                       <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                       <rect x="0.5" y="0.5" width="39" height="39" rx="4.5" fill="white"/>
                      <rect x="0.5" y="0.5" width="39" height="39" rx="4.5" stroke="#D9D9D9"/>
                      <path d="M10.0625 20.3481C9.97916 20.1236 9.97916 19.8766 10.0625 19.6521C10.8742 17.684 12.252 16.0012 14.0213 14.817C15.7905 13.6329 17.8715 13.0007 20.0005 13.0007C22.1295 13.0007 24.2105 13.6329 25.9797 14.817C27.749 16.0012 29.1268 17.684 29.9385 19.6521C30.0218 19.8766 30.0218 20.1236 29.9385 20.3481C29.1268 22.3163 27.749 23.9991 25.9797 25.1832C24.2105 26.3674 22.1295 26.9995 20.0005 26.9995C17.8715 26.9995 15.7905 26.3674 14.0213 25.1832C12.252 23.9991 10.8742 22.3163 10.0625 20.3481Z" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M20.0005 23.0001C21.6574 23.0001 23.0005 21.657 23.0005 20.0001C23.0005 18.3433 21.6574 17.0001 20.0005 17.0001C18.3437 17.0001 17.0005 18.3433 17.0005 20.0001C17.0005 21.657 18.3437 23.0001 20.0005 23.0001Z" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      </button> */}
											<div className={styles.tooltip}>
												<button
													className={styles.actionBtn}
													onClick={() =>
														onView?.(row)
													}
													aria-label="View user"
												>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="40"
														height="40"
														viewBox="0 0 40 40"
														fill="none"
													>
														<rect
															x="0.5"
															y="0.5"
															width="39"
															height="39"
															rx="4.5"
															fill="white"
														/>
														<rect
															x="0.5"
															y="0.5"
															width="39"
															height="39"
															rx="4.5"
															stroke="#D9D9D9"
														/>
														<path
															d="M10.0625 20.3481C9.97916 20.1236 9.97916 19.8766 10.0625 19.6521C10.8742 17.684 12.252 16.0012 14.0213 14.817C15.7905 13.6329 17.8715 13.0007 20.0005 13.0007C22.1295 13.0007 24.2105 13.6329 25.9797 14.817C27.749 16.0012 29.1268 17.684 29.9385 19.6521C30.0218 19.8766 30.0218 20.1236 29.9385 20.3481C29.1268 22.3163 27.749 23.9991 25.9797 25.1832C24.2105 26.3674 22.1295 26.9995 20.0005 26.9995C17.8715 26.9995 15.7905 26.3674 14.0213 25.1832C12.252 23.9991 10.8742 22.3163 10.0625 20.3481Z"
															stroke="#1E1E1E"
															stroke-width="1.5"
															stroke-linecap="round"
															stroke-linejoin="round"
														/>
														<path
															d="M20.0005 23.0001C21.6574 23.0001 23.0005 21.657 23.0005 20.0001C23.0005 18.3433 21.6574 17.0001 20.0005 17.0001C18.3437 17.0001 17.0005 18.3433 17.0005 20.0001C17.0005 21.657 18.3437 23.0001 20.0005 23.0001Z"
															stroke="#1E1E1E"
															stroke-width="1.5"
															stroke-linecap="round"
															stroke-linejoin="round"
														/>
													</svg>
												</button>
												<span
													className={
														styles.tooltipText
													}
												>
													View
												</span>
											</div>
											{/* <button className={styles.actionBtn} onClick={() => onMessage?.(row)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <rect x="0.5" y="0.5" width="39" height="39" rx="4.5" fill="white"/>
                        <rect x="0.5" y="0.5" width="39" height="39" rx="4.5" stroke="#D9D9D9"/>
                        <path d="M28 17.002C28.5304 17.002 29.0391 17.2127 29.4142 17.5877C29.7893 17.9628 30 18.4715 30 19.002V29.288C30 29.4284 29.9583 29.5656 29.8803 29.6824C29.8023 29.7991 29.6914 29.8901 29.5617 29.9438C29.432 29.9976 29.2892 30.0116 29.1515 29.9842C29.0138 29.9568 28.8873 29.8892 28.788 29.79L26.586 27.588C26.211 27.2129 25.7024 27.0021 25.172 27.002H18C17.4696 27.002 16.9609 26.7912 16.5858 26.4162C16.2107 26.0411 16 25.5324 16 25.002V24.002M24 18.002C24 18.5324 23.7893 19.0411 23.4142 19.4162C23.0391 19.7912 22.5304 20.002 22 20.002H14.828C14.2976 20.0021 13.789 20.2129 13.414 20.588L11.212 22.79C11.1127 22.8892 10.9862 22.9568 10.8485 22.9842C10.7108 23.0116 10.568 22.9976 10.4383 22.9438C10.3086 22.8901 10.1977 22.7991 10.1197 22.6824C10.0417 22.5656 10 22.4284 10 22.288V12.002C10 11.4715 10.2107 10.9628 10.5858 10.5877C10.9609 10.2127 11.4696 10.002 12 10.002H22C22.5304 10.002 23.0391 10.2127 23.4142 10.5877C23.7893 10.9628 24 11.4715 24 12.002V18.002Z" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button> */}
											<div className={styles.tooltip}>
												<button
													className={styles.actionBtn}
													onClick={() =>
														onMessage?.(row)
													}
													aria-label="Send message"
												>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="40"
														height="40"
														viewBox="0 0 40 40"
														fill="none"
													>
														<rect
															x="0.5"
															y="0.5"
															width="39"
															height="39"
															rx="4.5"
															fill="white"
														/>
														<rect
															x="0.5"
															y="0.5"
															width="39"
															height="39"
															rx="4.5"
															stroke="#D9D9D9"
														/>
														<path
															d="M28 17.002C28.5304 17.002 29.0391 17.2127 29.4142 17.5877C29.7893 17.9628 30 18.4715 30 19.002V29.288C30 29.4284 29.9583 29.5656 29.8803 29.6824C29.8023 29.7991 29.6914 29.8901 29.5617 29.9438C29.432 29.9976 29.2892 30.0116 29.1515 29.9842C29.0138 29.9568 28.8873 29.8892 28.788 29.79L26.586 27.588C26.211 27.2129 25.7024 27.0021 25.172 27.002H18C17.4696 27.002 16.9609 26.7912 16.5858 26.4162C16.2107 26.0411 16 25.5324 16 25.002V24.002M24 18.002C24 18.5324 23.7893 19.0411 23.4142 19.4162C23.0391 19.7912 22.5304 20.002 22 20.002H14.828C14.2976 20.0021 13.789 20.2129 13.414 20.588L11.212 22.79C11.1127 22.8892 10.9862 22.9568 10.8485 22.9842C10.7108 23.0116 10.568 22.9976 10.4383 22.9438C10.3086 22.8901 10.1977 22.7991 10.1197 22.6824C10.0417 22.5656 10 22.4284 10 22.288V12.002C10 11.4715 10.2107 10.9628 10.5858 10.5877C10.9609 10.2127 11.4696 10.002 12 10.002H22C22.5304 10.002 23.0391 10.2127 23.4142 10.5877C23.7893 10.9628 24 11.4715 24 12.002V18.002Z"
															stroke="#1E1E1E"
															stroke-width="1.5"
															stroke-linecap="round"
															stroke-linejoin="round"
														/>
													</svg>
												</button>
												<span
													className={
														styles.tooltipText
													}
												>
													Message
												</span>
											</div>
											{/* <button className={styles.actionBtn} onClick={() => onDelete?.(row)}>
                        
                      </button> */}
											{/* <div className={styles.tooltip}>
                        <button
                          className={styles.actionBtn}
                          onClick={() => onDelete?.(row)}
                          aria-label="Delete user"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <rect x="0.5" y="0.5" width="39" height="39" rx="4.5" fill="white" />
                            <rect x="0.5" y="0.5" width="39" height="39" rx="4.5" stroke="#D9D9D9" />
                            <path d="M18 19V25M22 19V25M27 14V28C27 28.5304 26.7893 29.0391 26.4142 29.4142C26.0391 29.7893 25.5304 30 25 30H15C14.4696 30 13.9609 29.7893 13.5858 29.4142C13.2107 29.0391 13 28.5304 13 28V14M11 14H29M16 14V12C16 11.4696 16.2107 10.9609 16.5858 10.5858C16.9609 10.2107 17.4696 10 18 10H22C22.5304 10 23.0391 10.2107 23.4142 10.5858C23.7893 10.9609 24 11.4696 24 12V14" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </button>
                        <span className={styles.tooltipText}>Delete</span>
                      </div> */}
											{onDelete && (
												<div className={styles.tooltip}>
													<button
														className={
															styles.actionBtn
														}
														onClick={() =>
															onDelete(row)
														}
														aria-label="Delete user"
													>
														<svg
															xmlns="http://www.w3.org/2000/svg"
															width="40"
															height="40"
															viewBox="0 0 40 40"
															fill="none"
														>
															<rect
																x="0.5"
																y="0.5"
																width="39"
																height="39"
																rx="4.5"
																fill="white"
															/>
															<rect
																x="0.5"
																y="0.5"
																width="39"
																height="39"
																rx="4.5"
																stroke="#D9D9D9"
															/>
															<path
																d="M18 19V25M22 19V25M27 14V28C27 28.5304 26.7893 29.0391 26.4142 29.4142C26.0391 29.7893 25.5304 30 25 30H15C14.4696 30 13.9609 29.7893 13.5858 29.4142C13.2107 29.0391 13 28.5304 13 28V14M11 14H29M16 14V12C16 11.4696 16.2107 10.9609 16.5858 10.5858C16.9609 10.2107 17.4696 10 18 10H22C22.5304 10 23.0391 10.2107 23.4142 10.5858C23.7893 10.9609 24 11.4696 24 12V14"
																stroke="black"
																stroke-width="1.5"
																stroke-linecap="round"
																stroke-linejoin="round"
															/>
														</svg>
													</button>
													<span
														className={
															styles.tooltipText
														}
													>
														Delete
													</span>
												</div>
											)}
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default GenericTable;
